module.exports = __webpack_public_path__ + "static/media/private_generator.c5f32314.svg";